import { useEffect, useRef } from 'react';

export const useAutoFocusInput = <T extends HTMLElement = HTMLInputElement>(
  block: ScrollLogicalPosition = 'center',
) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (ref.current) {
      if ('readOnly' in ref.current) {
        (ref.current as unknown as HTMLInputElement).readOnly = false;
      }
      ref.current.focus({ preventScroll: true });
      ref.current.scrollIntoView({
        block,
        behavior: 'smooth',
      });
    }
  }, []);

  return {
    ref,
    props: {
      autoComplete: 'off' as const,
      autoCorrect: 'off' as const,
      autoCapitalize: 'none' as const,
      readOnly: true,
    },
  };
};
